// 項目名から項目名のバリデート結果管理用のキー名を生成する
export const genValidKey = keyName => {
    return keyName + "_valid";
};